<section class="summary-section">

  <mat-card id="soldUnprocessedSummaryCard" class="summary-chart-card">

    <mat-toolbar class="chart-card-header-toolbar">
      <div class="right">
        <span class="chart-card-title summary-chart-card-title">
          Sold Unprocessed
          @if (auth.businessType() == 'Dealer') {
            <span class="chart-exception-title">*</span>
          }
        </span>
      </div>
      <!-- <div class="left">
        <button mat-button color="primary">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Sold Unprocessed' Report
        </button>
      </div>  -->
    </mat-toolbar>

    <mat-card-content>

      <span>Estimated Used vehicles delivered to a customer where a data deletion was not performed — highest-risk exposure.
      </span>

      @if (auth.businessType() == 'Dealer') {

        <span class="chart-exception-text">*Pre-owned inventory for sale only. Excludes new vehicles and loaners.</span>

        <!-- <div class="chart-exception-warn-text-wrapper">
          <mat-icon>warning</mat-icon>
          <span class="chart-exception-warn-text">*Showing Used vehicles only. <br> *New/Loaner vehicles are excluded from this report.</span>
        </div> -->

      }

      @if (soldUnprocessedCountsLoading) {
        <div class="loader-wrapper">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else if (soldUnprocessedCounts != undefined) {
        <div class="sold-unprocessed-counts-wrapper">

          <div class="sold-unprocessed-counts-container">

            <mat-card class="sold-unprocessed-count-card">
              <!-- <mat-card-content> -->

                <div class="sold-unprocessed-count-hero">
                  <span class="sold-unprocessed-count-number">{{soldUnprocessedCounts.last24Hours}}</span>
                  <span class="sold-unprocessed-count-unit-text">sold unprocessed</span>
                </div>

                <div class="sold-unprocessed-count-title-container">
                  <span class="sold-unprocessed-count-title">
                    in the last 24 hours
                  </span>
                </div>

                <!-- <span class="sold-unprocessed-count-subtitle">
                  were sold without deleting data
                </span> -->
              <!-- </mat-card-content> -->
            </mat-card>

            <!-- <span class="sold-unprocessed-count-title">
              last 24 hours
            </span> -->

          </div>

          <div class="sold-unprocessed-counts-container">

            <mat-card class="sold-unprocessed-count-card">
              <!-- <mat-card-content> -->

                <div class="sold-unprocessed-count-hero">
                  <span class="sold-unprocessed-count-number">{{soldUnprocessedCounts.last7Days}}</span>
                  <span class="sold-unprocessed-count-unit-text">sold unprocessed</span>
                </div>

                <div class="sold-unprocessed-count-title-container">
                  <span class="sold-unprocessed-count-title">
                    in the last 7 days
                  </span>
                </div>

                <!-- <span class="sold-unprocessed-count-subtitle">
                  were sold without deleting data
                </span> -->
              <!-- </mat-card-content> -->
            </mat-card>

            <!-- <span class="sold-unprocessed-count-title">
              last 7 days
            </span> -->

          </div>

          <div class="sold-unprocessed-counts-container">

            <mat-card class="sold-unprocessed-count-card">
              <!-- <mat-card-content> -->

                <div class="sold-unprocessed-count-hero">
                  <span class="sold-unprocessed-count-number">{{soldUnprocessedCounts.last30Days}}</span>
                  <span class="sold-unprocessed-count-unit-text">sold unprocessed</span>
                </div>

                <div class="sold-unprocessed-count-title-container">
                  <span class="sold-unprocessed-count-title">
                    in the last 30 days
                  </span>
                </div>

                <!-- <span class="sold-unprocessed-count-subtitle">
                  were sold without deleting data
                </span> -->
              <!-- </mat-card-content> -->
            </mat-card>

            <!-- <span class="sold-unprocessed-count-title">
              last 30 days
            </span> -->

          </div>

        </div>

      }

    </mat-card-content>

    <!-- <mat-card-actions>
      <button mat-button color="primary" routerLink="/sold-unprocessed">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Sold Unprocessed' Report
        </button>
    </mat-card-actions> -->

  </mat-card>

</section>

<mat-card class="table-card">

  <mat-toolbar class="chart-card-header-toolbar">
    <div class="right">
      <span class="chart-card-title">Sold Unprocessed Details</span>
      @if (auth.businessType() == 'Dealer') {
        <span class="chart-exception-subtitle">*Pre-owned inventory for sale only. Excludes new vehicles and loaners.</span>
      }
    </div>
    <div class="left">
      <button mat-raised-button color="primary" [matTooltip]="csvDownloadHint" (click)="exportUnprocessedSoldVinReportCSV()">
        <mat-icon>download</mat-icon>
        Export to CSV
      </button>
    </div>
  </mat-toolbar>

  @if (tableLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="filter-bar-wrapper">
    <app-filter-bar [defaultPreset]="'last14'" fixedEndDate />
  </div>

  <div class="table-scroll">
    <table class="soldUnprocessed-vin-table" mat-table [dataSource]="dataSource.filteredData">

      <ng-container matColumnDef="saleDate">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Sale Date<mat-icon [matTooltip]="tableHeaderTooltips.saleDate">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{formatDateTime(row.saleDate)}}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Status<mat-icon [matTooltip]="tableHeaderTooltips.status">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.status}}</td>
      </ng-container>

      <ng-container matColumnDef="vinCode">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">VIN Code<mat-icon [matTooltip]="tableHeaderTooltips.vinCode">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.vinCode}}</td>
      </ng-container>

      <ng-container matColumnDef="decodedMake">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Decoded Make<mat-icon [matTooltip]="tableHeaderTooltips.decodedMake">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.decodedMake}}</td>
      </ng-container>

      <ng-container matColumnDef="decodedModel">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Decoded Model<mat-icon [matTooltip]="tableHeaderTooltips.decodedModel">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.decodedModel}}</td>
      </ng-container>

      <ng-container matColumnDef="decodedYear">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Decoded Year<mat-icon [matTooltip]="tableHeaderTooltips.decodedYear">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.decodedYear}}</td>
      </ng-container>

      <ng-container matColumnDef="processorSite">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Processor Site<mat-icon [matTooltip]="tableHeaderTooltips.processorSite">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.processorSite}}</td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">User Name<!-- <mat-icon [matTooltip]="tableHeaderTooltips.username">info_outline</mat-icon> --></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.userName}}</td>
      </ng-container>

      <ng-container matColumnDef="controllerName">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Controller Name<mat-icon [matTooltip]="tableHeaderTooltips.controllerName">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.controllerName}}</td>
      </ng-container>

      <ng-container matColumnDef="controllerId">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Controller ID<mat-icon [matTooltip]="tableHeaderTooltips.controllerId">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.controllerID}}</td>
      </ng-container>

      <ng-container matColumnDef="classification">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Classification<mat-icon [matTooltip]="tableHeaderTooltips.classification">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.classification}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length">No scans match the filter.</td>
      </tr>
    </table>
  </div>

  <!-- Disabled while loading: cursor pagination can't skip a page it hasn't
       fetched, so a second click before the first lands would desync the
       paginator from the rows. -->
  <mat-paginator [disabled]="tableLoading" [pageSize]="data.scanTablePagination().pageSize" [length]="data.scanTablePagination().total" (page)="paginatorEventHandler($event)"></mat-paginator>

</mat-card>
